import { CustomerErrorCodeEnum } from 'types/error';

type IgnoreRule = string | RegExp;

/**
 * 上报忽略规则
 *·
 * 你可以通过string或者正则来匹配要过滤上报的信息，可以匹配errorClass、errorMessage以及userAgent
 *
 * 例如：[/micromessenger/i, 'UnhandledRejection', /^Failed to execute 'insertBefore' on 'Node'/]
 */
export default [
    'OFF_LINE', // 离线
    504, // 超时
    -1, // 未知问题
    'CANCEL',
    'UnhandledRejection',
    11012, // 设备风险错误
    11072, // A phone number has already been added.
    11074, // Please first try the SMS verification code.
    /^Loading CSS chunk/,
    'ChunkLoadError',
    /vivoNewsDetailPage.getNewsReadStatus4Vivo/,
    /\.NET CLR/, // 特殊爬虫环境
    // https://app.bugsnag.com/tigerbrokers/fed-tiger-open-account/errors/5c55f2593ff44c0019ed5ffb
    /^Blocked a frame with origin/,
    // checkInfo的报错，ssn号码已经开过户时候的报错
    /The entered SSN is already associated with an account/,
    /您输入的SSN已关联了其他账户/,
    CustomerErrorCodeEnum.APPLICATION_PRODUCT_DUPLICATE_SUBMIT, // 重复提交申请
    CustomerErrorCodeEnum.IDNO_CHECK_FAILED,
    CustomerErrorCodeEnum.SSN_ALREADY_ASSOCIATED
] as IgnoreRule[];
